<template>
  <div>
    <div v-if="boletoFormatado">
      <div
        class="capa page"
        v-if="dados.dadosEmpresa.boletoComCapaEContracapa == 1 && !isInterno()"
      >
        <img :src="dados.dadosEmpresa.capa" />
      </div>
      <div class="page-interno">
        <div class="cabecalho">
          <div class="vx-row">
            <div
              class="vx-col sm:w-1/4 w-full mb-2"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <img
                :src="dados.dadosEmpresa.logo"
                style="max-height: 120px; max-width: 100%"
              />
            </div>
            <div
              class="vx-col sm:w-3/4 w-full text-center"
              style="
                padding: 15px 10px;
                font-weight: 500;
                justify-content: center;
              "
            >
              <!-- <div>ADM COBRANÇA E RECEBIVEIS LTDA</div>
              <small class="mt-3">
                {{ dados.dadosEmpresa.endereco }},
                {{ dados.dadosEmpresa.numero }}
                {{ dados.dadosEmpresa.complemento }},
                {{ dados.dadosEmpresa.bairro }},
                {{ dados.dadosEmpresa.cidade }} /
                {{ dados.dadosEmpresa.estado }} - CEP:
                {{ dados.dadosEmpresa.cep }}
                <br />
                Tel.: (31) 3972-5000
                <br />
                CNPJ: {{ dados.dadosEmpresa.cpfcnpj }}
              </small> -->
            </div>
          </div>
        </div>
        <div class="cabecalho p-1">
          <h6>AO BENEFICIÁRIO(A)</h6>
          <br />
          <p
            class="text-xs"
            v-if="
              dados.dadosCobranca.referente &&
              dados.dadosCobranca.idTipoBoleto != 4
            "
          >
            Referente a: {{ dados.dadosCobranca.referente }}
          </p>
          <br />
          <p class="text-xs mb-2 font-light">Prezado(a) Beneficiário(a)</p>
          <br />
          <p class="text-xs mb-2 font-light">
            Nosso número da assistência 24h é
            <a href="tel:+5508009445000">0800-944-5000.</a>
          </p>
          <p class="text-xs mb-2 font-light">
            O pagamento deste boleto não quita débitos anteriores. Pague em dia
            e mantenha sua cobertura ativa.
          </p>
          <p
            v-if="dados.dadosCobranca.idTipoBoleto != 4"
            class="text-xs mb-2 font-light"
          >
            Boleto válido até 5 dias corridos após o vencimento. Passado o
            prazo, será necessário uma nova vistoria do veículo.
          </p>
          <p class="text-xs mb-2 font-light">
            Para acesso imediato a segunda via de boletos, aviso de eventos,
            entre outros recursos através de nosso app Bem Protege, disponível
            na app store (IOS) e na play store (ANDROID)
          </p>
          <p class="text-xs mb-2 font-light">
            ATENÇÃO: Mantenha o seu cadastro atualizado junto a Bem Protege,
            como por exemplo: endereço, e-mail e número de telefone. Para isto,
            basta entrar em contato conosco na Central de Atendimento:
            <a href="tel:+553139725000">(31) 3972-5000</a> /
            <a href="tel:+5531999026001">(31) 99902-6001.</a>
          </p>
          <div class="text-xs mb-2 font-light">
            <div v-if="dados.dadosVeiculos && dados.dadosVeiculos.length > 0">
              <ul class="flex">
                <li
                  class="d-inline mr-2"
                  v-for="veiculo in dados.dadosVeiculos"
                  :key="veiculo.id_veiculo"
                >
                  {{
                    veiculo.placa
                      ? `Placa: ${veiculo.placa}`
                      : `Chassi: ${veiculo.chassi}`
                  }}
                </li>
              </ul>
            </div>
            <div v-else>
              {{
                dados.dadosCobranca.placa
                  ? `Placa: ${dados.dadosCobranca.placa}`
                  : `Chassi: ${dados.dadosCobranca.chassi}`
              }}
            </div>

            <div v-if="dados.dadosAgregados && dados.dadosAgregados.length > 0">
              <ul class="flex">
                <li
                  class="d-inline mr-2"
                  v-for="agregado in dados.dadosAgregados"
                  :key="agregado.idComplemento"
                >
                  {{
                    agregado.placa
                      ? `Placa: ${agregado.placa}`
                      : `Chassi: ${agregado.chassi}`
                  }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div v-if="dados.dadosCobranca.pix" class="cabecalho p-2 px-8 bg-grey">
          <div class="flex justify-between flex-col items-center">
            <div class="flex items-center flex-col justify-between">
              <h6 class="text-center">PAGUE VIA PIX:</h6>
              <b class="">
                Agora você também pode pagar nossos boletos via Pix.<br />
                Basta abrir o APP e escanear o QR Code. Experimente!
              </b>
              <div
                class="flex items-center justify-center flex-col mt-2 gap-2 pointer"
              >
                <div
                  class="py-2 px-4 rounded-full flex items-center justify-center main-primary main-primary-hover text-white gap-2"
                  @click="copyToClipboard(dados.dadosCobranca.pix)"
                >
                  <CopyIcon class="icon" />
                  Copiar Código PIX
                </div>
                <p class="text-center text-xs">{{ dados.dadosCobranca.pix }}</p>
              </div>
            </div>
            <div class="flex items-center justify-center w-full mt-2">
              <VueQr :text="dados.dadosCobranca.pix" class="imgPix" />
            </div>
          </div>
        </div>

        <div class="cabecalho mt-4 pb-4 ultimoCabecalho">
          <div class="vx-row">
            <div class="vx-col sm:w-1/5 w-full mt-2">
              <h6>Vencimento:</h6>

              <b>{{ formataData(dados.dadosCobranca.dataVencimento) }}</b>
            </div>
            <div class="vx-col sm:w-1/5 w-full mt-2">
              <h6>Valor:</h6>

              <b>{{
                Number(dados.dadosCobranca.valor).toFixed(2) | currency
              }}</b>
            </div>
            <div
              class="vx-col sm:w-3/5 w-full mt-2"
              v-if="showCodeBarAndDigitalLine()"
            >
              <h6>Linha DIGITÁVEL:</h6>

              <b>{{ dados.dadosCobranca.linhaDigitavel }}</b>
            </div>
          </div>
        </div>
        <div class="linhaCorte">Corte da linha pontilhada</div>
        <div class="">
          <table class="table">
            <tr>
              <td width="250px">
                <img :src="dados.dadosCobranca.banco.logoBanco" height="35px" />
              </td>
              <td class="linhaDigitavelOverBoleto" valing="bottom">
                <b
                  >{{ dados.dadosCobranca.banco.codigoBanco }}-{{
                    dados.dadosCobranca.banco.digitoBanco
                  }}</b
                >
                <span v-if="showCodeBarAndDigitalLine()">{{
                  dados.dadosCobranca.linhaDigitavel
                }}</span>
              </td>
            </tr>
          </table>
          <table class="table table-bordered table-boleto">
            <tr>
              <td colspan="5">
                Local de pagamento
                <b
                  >Pagar preferencialmente no
                  {{ dados.dadosCobranca.banco.nomeBanco }}
                </b>
              </td>
              <td class="ultimaColuna">
                Vencimento
                <b>{{ formataData(dados.dadosCobranca.dataVencimento) }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                Cedente
                <b>{{ dados.dadosEmpresa.nome }}</b>
              </td>
              <td class="ultimaColuna">
                Agência/Código cedente<br />
                <b
                  >{{ dados.dadosCobranca.banco.agencia }}/{{
                    dados.dadosCobranca.banco.conta
                  }}</b
                >
              </td>
            </tr>
            <tr>
              <td>
                Data do documento <br />
                <b>{{ formataData(dados.dadosCobranca.dataEmissao) }}</b>
              </td>
              <td>
                Nº documento<br /><b>{{
                  bancosIncluiIdRemessaBoleto.includes(
                    dados.dadosCobranca.banco.codigoBanco,
                  )
                    ? dados.dadosCobranca.idRemessaBoleto
                    : dados.dadosCobranca.id
                }}</b>
              </td>
              <td>Espécie doc.<br /></td>
              <td>Aceite<br /><b>N</b></td>
              <td>
                Data processamento <br />
                <b>{{ formataData(dados.dadosCobranca.dataEmissao) }}</b>
              </td>
              <td class="ultimaColuna">
                Nosso número<br /><b>{{ dados.dadosCobranca.nossoNumero }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Carteira <b>{{ dados.dadosCobranca.banco.carteira }}</b>
              </td>
              <td>Espécie <b>REAL</b></td>
              <td>Parcela</td>
              <td>Valor {{ dados.dadosCobranca.valor.toFixed(2) }}</td>
              <td class="ultimaColuna">
                (=) Valor documento <br />
                <b>{{ dados.dadosCobranca.valor.toFixed(2) }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                Instruções (Texto de responsabilidade do cedente)<br />
                <b>{{ dados.dadosCobranca.instrucao }}</b>
                <p v-if="dados.dadosCobranca.multa !== null">
                  <b
                    >Multa {{ dados.dadosCobranca.multa.toFixed(2) }}%, Juros
                    {{ dados.dadosCobranca.juros.toFixed(2) }}%</b
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                Pagador<br />
                <b
                  >{{ dados.dadosPagador.nome }} /
                  {{ dados.dadosPagador.cpfcnpj }}<br />
                  RUA {{ dados.dadosPagador.endereco }},
                  {{ dados.dadosPagador.numero }}
                  {{ dados.dadosPagador.complemento }},
                  {{ dados.dadosPagador.bairro }}<br />
                  {{ dados.dadosPagador.cep }} -
                  {{ dados.dadosPagador.cidade }} -
                  {{ dados.dadosPagador.estado }}</b
                >
              </td>
              <td class="ultimaColuna">Cód. Baixa</td>
            </tr>
          </table>
          <table class="table" style="font-size: 10px">
            <tr>
              <td width="65%">
                CNPJ Beneficiário: {{ dados.dadosEmpresa.cpfcnpj }}
              </td>
              <td align="right">
                <b>Autenticação mecânica - Ficha de Compensação</b>
              </td>
            </tr>
          </table>
          <div class="barcode text-center" v-if="showCodeBarAndDigitalLine()">
            <barcode
              v-bind:value="dados.dadosCobranca.barCode"
              format="itf"
              :displayValue="false"
              :width="1.75"
              :height="50"
            >
              Show this if the rendering fails.
            </barcode>
          </div>
        </div>
      </div>
      <div
        class="contracapa page"
        v-if="dados.dadosEmpresa.boletoComCapaEContracapa == 1 && !isInterno()"
      >
        <img :src="dados.dadosEmpresa.contracapa" style="max-width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import VueQr from 'vue-qr';
import { CopyIcon } from 'vue-feather-icons';

export default {
  name: 'boleto-bemProtege',
  props: ['dadosBoleto'],
  data() {
    return {
      boletoFormatado: false,
      interno: this.$route.query.interno,
      dados: {},
      bancos: {
        itau: {
          nomeBanco: 'Banco Itaú',
          logoBanco: 'https://bboneapp.s3.amazonaws.com/logo-itau.png',
          codigoBanco: '341',
          digitoBanco: '7',
          agencia: '7892',
          conta: '99886',
          carteira: '109',
        },
        santander: {
          nomeBanco: 'Banco Santander',
          logoBanco: 'https://bboneapp.s3.amazonaws.com/logo-santander.png',
          codigoBanco: '033',
          digitoBanco: '7',
          agencia: '1004',
          conta: '0220060',
          carteira: '101',
        },
      },
      bancosIncluiIdRemessaBoleto: ['104'],
    };
  },
  methods: {
    isInterno() {
      if (this.interno) {
        return /true/.test(this.interno);
      } else return false;
    },
    formataData(data) {
      const [date, _] = data.split('T');
      const [ano, mes, dia] = date.split('-');
      const _date = `${dia}/${mes}/${ano}`;

      return _date;
    },
    formataLinhaDigitavel(linha) {
      return linha.replace(
        /(\d{5})?(\d{5})?(\d{5})?(\d{6})?(\d{5})?(\d{6})?(\d{1})?(\d{14})/,
        '$1.$2.$3.$4.$5.$6.$7.$8',
      );
    },
    pegarDados() {
      const dados = this._props.dadosBoleto;
      const TIME = 2000;
      const {
        origem,
        dadosToBoleto: {
          dadosCobranca: { banco, linhaDigitavel },
        },
      } = dados;

      if (origem === 'Galaxpay') {
        dados.dadosToBoleto.dadosCobranca.banco = this.bancos[banco];
        dados.dadosToBoleto.dadosCobranca.linhaDigitavel =
          this.formataLinhaDigitavel(linhaDigitavel);
      }
      this.dados = dados.dadosToBoleto;
      this.boletoFormatado = true;
      this.imprimir(TIME);
    },
    imprimir(TIME = 1000) {
      setTimeout(() => {
        window.print();
      }, TIME);
    },
    showCodeBarAndDigitalLine() {
      const ID_TIPO_BOLETO = 4;
      const isPix = Boolean(this.dadosBoleto.pixQrCode);
      const shouldDisplayBoleto = !(
        isPix && this.dadosBoleto.idTipoBoleto === ID_TIPO_BOLETO
      );
      return shouldDisplayBoleto;
    },
    copyToClipboard(codePix) {
      navigator.clipboard.writeText(codePix);
      this.$vs.notify({
        position: 'top-center',
        text: 'Pix copiado para a área de transferência.',
        color: 'success',
      });
    },
  },
  mounted() {
    this.pegarDados();
  },
  components: { barcode: VueBarcode, VueQr, CopyIcon },
};
</script>
<style lang="scss" scoped>
.table {
  width: 100%;
}
.table-boleto {
  font-size: 10px;
}

.imgPix {
  height: 130px;
}
.bg-grey {
  background-color: #e7e7e7 !important;
}

.cabecalho {
  font-size: 12px;
  border-bottom: 1px solid #e7e7e7;
  h6 {
    font-size: 14px;
    text-transform: uppercase;
    font-weight: bolder;
  }
}
.ultimoCabecalho {
  border-bottom: 0px !important;
}

.linhaCorte {
  border-bottom: 1px dashed #ccc;
  text-align: right;
  padding: 5px;
  font-size: 10px;
  margin: 10px 0;
}
.veiculo {
  width: 33%;
  float: left;
  margin-bottom: 10px;
}
.barcode div svg {
  width: 90% !important;
}
.linhaDigitavelOverBoleto {
  vertical-align: bottom;
  text-align: right;
  font-size: 12px;
  b {
    font-size: 20px;
  }
  span {
    line-height: 30px;
    margin-left: 10px;
  }
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 0px;
  border-color: grey;
  border: 1px solid grey;

  width: 100%;
  tr td {
    padding: 5px;
    border: 1px solid grey;
    border-bottom: 0px;
    border-right: 0px;
  }
  tr:first-child td {
    border-top: 0px;
  }
  tr td:first-child {
    border-left: 0px;
  }
  tr td:last-child {
    border-right: 1px;
  }
}
.tableinfo td {
  width: 1%;
}

.page img {
  max-width: 100%;
  width: 100%;
  height: auto;
}
.icon {
  width: 16px;
  height: 16px;
  color: #fff;
}
.pointer {
  cursor: pointer;
}
.main-primary {
  background-color: #114880;
}
.main-primary-hover:hover {
  background-color: #145699;
}
</style>
